(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["adeline-installments"] && !Shopify.designMode) return;
  try {
    (() => {
    const money = cents => (cents / 100).toFixed(2) + ' ₪';
    document.addEventListener('variant:update', event => {
      const variant = event.detail?.resource;
      if (!variant || typeof variant.price !== 'number') return;
      document.querySelectorAll('[data-adeline-installments]').forEach(el => {
        const count = parseInt(el.dataset.count, 10) || 3;
        const min = parseInt(el.dataset.min, 10) || 0;
        el.hidden = variant.price < min;
        el.textContent = el.dataset.template.replace('[count]', count).replace('[amount]', money(Math.round(variant.price / count)));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["adeline-product-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
    const pad = n => String(n);
    const addBusinessDays = (from, days) => {
      const d = new Date(from);
      let left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        const wd = d.getDay();
        if (wd !== 5 && wd !== 6) left -= 1;
      }
      return d;
    };
    const fmt = d => pad(d.getDate()) + '.' + pad(d.getMonth() + 1);
    const setEta = root => root.querySelectorAll('[data-adeline-eta]').forEach(el => {
      const min = parseInt(el.dataset.min, 10);
      const max = parseInt(el.dataset.max, 10);
      if (!min || !max || max < min) return;
      const now = new Date();
      el.textContent = el.dataset.label + ' ' + fmt(addBusinessDays(now, min)) + '-' + fmt(addBusinessDays(now, max));
    });
    setEta(document);
    document.addEventListener('shopify:section:load', e => setEta(e.target));
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-adeline-share]');
      if (!link || !navigator.share || !matchMedia('(pointer: coarse)').matches) return;
      event.preventDefault();
      navigator.share({ title: link.dataset.title, text: link.dataset.text + ' ' + link.dataset.title, url: link.dataset.url }).catch(() => {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["adeline-size-guide"] && !Shopify.designMode) return;
  try {
    class AdelineFitGuide extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.adeline-fit-guide__open');
      this.scope = this.closest('.product-information');
      this.section = this.closest('.shopify-section');
      this.picker = this.scope?.querySelector('variant-picker');
      this.sizeInputs = [...(this.picker?.querySelectorAll('input[type="radio"]') || [])].filter(input => /^(מידה|מידות|size)$/i.test(input.dataset.optionName || ''));
      this.confirmed = !this.sizeInputs.length || Boolean(this.dataset.selectedVariant);
      if (!this.confirmed) {
        this.sizeInputs.forEach(input => {
          input.checked = false;
          input.dataset.currentChecked = 'false';
          input.dataset.previousChecked = 'false';
        });
        this.querySelector('[data-selected-options]').textContent = '';
        const stickyVariant = this.section?.querySelector('.sticky-add-to-cart__variant');
        if (stickyVariant) stickyVariant.textContent = this.dataset.chooseLabel;
        this.querySelector('[data-size-prompt]').hidden = true;
      }
      const guard = event => {
        const buying = event.type === 'submit' ? event.target.closest('product-form-component') : event.target.closest('.add-to-cart-button');
        if (this.confirmed || !buying) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const prompt = this.querySelector('[data-size-prompt]');
        prompt.hidden = false;
        this.sizeInputs.forEach(input => {
          input.setAttribute('aria-invalid', 'true');
          const descriptions = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
          descriptions.add(prompt.id);
          input.setAttribute('aria-describedby', [...descriptions].join(' '));
        });
        this.scrollIntoView({ block: 'center', behavior: 'auto' });
        prompt.focus({ preventScroll: true });
      };
      this.section?.addEventListener('click', guard, { ...options, capture: true });
      this.section?.addEventListener('submit', guard, { ...options, capture: true });
      this.trigger.addEventListener('click', () => this.dialog.showModal(), options);
      this.querySelector('[data-fit-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.trigger.focus(), options);
      this.scope?.addEventListener('change', event => {
        if (!event.target.closest('variant-picker')) return;
        if (/^(מידה|מידות|size)$/i.test(event.target.dataset.optionName || '')) {
          this.confirmed = true;
          this.querySelector('[data-size-prompt]').hidden = true;
          const promptId = this.querySelector('[data-size-prompt]').id;
          this.sizeInputs.forEach(input => {
            input.removeAttribute('aria-invalid');
            const descriptions = (input.getAttribute('aria-describedby') || '').split(' ').filter(id => id && id !== promptId);
            if (descriptions.length) input.setAttribute('aria-describedby', descriptions.join(' '));
            else input.removeAttribute('aria-describedby');
          });
        }
        const picker = this.scope.querySelector('variant-picker');
        const chosen = [...picker.querySelectorAll('input:checked, select option:checked')].map(input => input.value);
        this.querySelector('[data-selected-options]').textContent = chosen.join(' / ');
      }, options);
    }
    disconnectedCallback() { this.dialog?.close(); this.controller?.abort(); }
  }
  if (!customElements.get('adeline-fit-guide')) customElements.define('adeline-fit-guide', AdelineFitGuide);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-adeline-cookie-preferences]');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    const popover = link.closest('[popover]');
    if (popover?.matches(':popover-open')) popover.hidePopover();
    Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {
      window.location.assign(link.href);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
